import React, { useEffect, useRef, useState } from "react";

import { ExpandIcon } from "../../components";
import { useTicketingContext } from "../../store";

const Select = ({ id, style, options, handleOnChange }) => {
  const { state } = useTicketingContext();
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const expandButton = useRef(null);
  const selectOptions = useRef(null);

  useEffect(() => {
    const defaultCurrency = options.find((currency) =>
      state.selectedCurrency
        ? currency.label === state.selectedCurrency
        : currency.label === "DKK"
    );
    setSelectedOption(defaultCurrency.label);
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        selectOptions.current &&
        expandButton.current &&
        event.target &&
        !selectOptions.current.contains(event.target) &&
        !expandButton.current.contains(event.target)
      ) {
        setIsExpanded(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selectOptions, expandButton]);

  const handleOnClick = (e) => {
    setSelectedOption(e.target.dataset.label);
    handleOnChange(e.target.dataset.value);
  };

  const filteredOptions = options.filter(
    (option) => option.label !== selectedOption
  );

  return (
    <div
      className={`select-wrapper-react select-${id}-react ${
        isExpanded ? "expanded" : ""
      }`}
      onClick={() => setIsExpanded((current) => !current)}
      style={style}
    >
      <div className="selected-option" ref={expandButton}>
        <span className="option-name">{selectedOption}</span>
        <span className="expand-icon">
          <ExpandIcon rotationDegree={isExpanded ? "180" : 0} />
        </span>
      </div>
      {isExpanded ? (
        <div className="options" ref={selectOptions}>
          {filteredOptions.map((option) => (
            <div
              className="select-option"
              data-label={option.label}
              data-value={option.value}
              key={option.value}
              onClick={handleOnClick}
            >
              {option.label}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default Select;
